import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRequest, postRequest } from "../../../../helpers/request";
import { appApi } from "../../../../utils/endpoints/appApi";
import $ from "jquery";
import "bootstrap-select/dist/css/bootstrap-select.min.css";
import "bootstrap-select/dist/js/bootstrap-select.min.js";
import { onChangeStatus } from "../../../../config/redux/slice/bankUserSlice";
import {
  onChangeStatus as onChangeStatusNotap,
  onEvalSent,
  showSendEvalFormFunc,
  showStatusReConfirmFunc,
} from "../../../../config/redux/slice/notapUserSlice";
import {
  clearAll,
  setErrorMessageNotapUser,
  setLoadingNotapUser,
} from "../../../../config/redux/slice/notapUserSlice";
import { Spinner } from "../../../components";
import { showStatusChangeConfirmationFunc } from "../../../../config/redux/slice/notapUserSlice";
import { useForm } from "react-hook-form";
import StatusChangeReConfirm from "./StatusChangeReConfirm";

export default function SendEvalModal() {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    formState: { errors },
    reset,
  } = useForm({ mode: "onTouched" });
  const {
    certificateManagement: { certificateDetails },
    evaluationManagement: { evalStatus, evalId, evaluationDetails },
  } = useSelector((state) => state.notapUser);
  const {
    certificateManagement: { showStatusReConfirm },
  } = useSelector((state) => state.notapUser);
  const {
    token,
    userData: { user_role, user_role_id, isAdmin, email },
  } = useSelector((state) => state.authData);
  const [actionObj, setActionObj] = useState({});
  const [notapStaff, setNotapStaff] = useState([]);
  const [deputyDirectors, setDeputyDirectors] = useState([]);
  const [officers, setOfficers] = useState([]);
  const [isFetchingStaff, setIsFetchingStaff] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultNextStaff, setDefaultNextStaff] = useState({});

  useEffect(() => {
    getNotapStaff();
  }, []);

  const closeModal = () => {
    dispatch(clearAll({}));
    dispatch(showSendEvalFormFunc({ modal: false, status: "", evalId: null }));
  };

  // const confirmAction = async (data) => {
  //     dispatch(clearAll({}))
  //     let payload = {
  //       ...data,
  //         comment_mode: 'EXTERNAL'
  //     }
  //     setActionObj(payload)
  //     dispatch(showStatusReConfirmFunc({modal: true}))
  // }

  const getNotapStaff = async () => {
    dispatch(clearAll({}));
    setIsFetchingStaff(true);

    const res = await getRequest(
      token,
      `${appApi.getStaff}`,
      {},
      dispatch,
      "",
      "",
      setErrorMessageNotapUser
    );
    if (res != undefined && res.status < 400) {
      let dataList = res.data.data.filter(
        (resItem) =>
          resItem.EMAIL != email && resItem.USER_ROLE_TEXT.toLowerCase() != "dg"
      );
      setNotapStaff(dataList);
      if (user_role.toLowerCase() == "deputydirector") {
        let notapOfficers = dataList.filter(
          (officer) => officer.USER_ROLE_TEXT.toLowerCase() == "officers"
        );
        setOfficers(notapOfficers);
      } else if (
        user_role.toLowerCase() == "director" ||
        user_role.toLowerCase() == "officers"
      ) {
        let notapOfficers = dataList.filter(
          (officer) => officer.USER_ROLE_TEXT.toLowerCase() == "deputydirector"
        );
        setDeputyDirectors(notapOfficers);
      }

      let nextUser;
      if (user_role.toLowerCase() == "officers") {
        nextUser = dataList.filter(
          (dataObj) => Number(user_role_id) - 1 == dataObj.USER_ROLE_ID
        );
      } else if (
        user_role.toLowerCase() == "dg" ||
        user_role.toLowerCase() == "director"
      ) {
        nextUser = dataList.filter(
          (dataObj) => Number(user_role_id) + 1 == dataObj.USER_ROLE_ID
        );
      } else if (certificateDetails?.EVALUATION_DIRECTION == "backward") {
        nextUser = dataList.filter(
          (dataObj) => Number(user_role_id) - 1 == dataObj.USER_ROLE_ID
        );
      } else if (certificateDetails?.EVALUATION_DIRECTION == "forward") {
        nextUser = dataList.filter(
          (dataObj) => Number(user_role_id) + 1 == dataObj.USER_ROLE_ID
        );
      }
      setDefaultNextStaff(nextUser?.[0]);

      if (user_role.toLowerCase() == "deputydirector") {
        $(function () {
          $(".my-staff-select").selectpicker();
          //   ll
        });
      }
      // else if(user_role.toLowerCase() == 'director'){
      //     $(function () {
      //         $('.my-director-select').selectpicker();
      //         //   ll
      //     });
      // }
      setIsFetchingStaff(false);
    } else {
      setIsFetchingStaff(false);
    }
  };

  const onSend = async (data) => {
    dispatch(clearAll({}));
    setIsLoading(true);
    let next_user_email;
    if (data.flowType == "option1") {
      if (
        certificateDetails?.EVALUATION_DIRECTION == "forward" &&
        ["director", "deputydirector", "officers"].includes(
          user_role.toLowerCase()
        )
      ) {
        next_user_email = data.next_user_email;
      } else {
        next_user_email = defaultNextStaff.EMAIL;
      }
    } else if (data.flowType == "option3") {
      next_user_email = "";
    } else {
      next_user_email = data?.next_user_email;
    }
    //  = data.flowType == 'option1' ? defaultNextStaff.EMAIL : data.next_user_email
    let next_user_name = notapStaff.filter(
      (staff) => staff.EMAIL == next_user_email
    );
    let evaluation_direction;
    if (
      user_role.toLowerCase() == "dg" ||
      user_role.toLowerCase() == "director"
    ) {
      evaluation_direction = "forward";
    } else if (user_role.toLowerCase() == "officers") {
      evaluation_direction = "backward";
    }
    // else if(user_role.toLowerCase() == 'director'){
    //     let staffObj = notapStaff.filter((staff)=>staff.EMAIL == next_user_email)
    //     if((staffObj[0].USER_ROLE_TEXT).toLowerCase() == 'dg'){
    //         evaluation_direction = 'backward'
    //     }else{
    //         evaluation_direction = 'forward'
    //     }
    // }
    else {
      evaluation_direction = certificateDetails?.EVALUATION_DIRECTION;
    }
    data = {
      ...data,
      comment: evaluationDetails.COMMENTS,
      letter: evaluationDetails.LETTER,
      certificate_id: certificateDetails?.ID,
      status: evalStatus,
      next_user_name: `${next_user_name[0]?.FIRST_NAME} ${next_user_name[0]?.LAST_NAME}`,
      evaluation_id: evalId,
      next_user_email,
      evaluation_direction,
    };

    const res = await postRequest(
      token,
      `${appApi.submitEvaluation}`,
      data,
      dispatch,
      "",
      onEvalSent,
      setErrorMessageNotapUser
    );
    if (res !== undefined) {
      setIsLoading(false);
    }
  };

  const flowTypeValue = watch("flowType");

  //    useEffect(()=>{
  //     if(user_role.toLowerCase() == 'deputydirector'){
  //         $(function () {
  //             $('.my-staff-select').selectpicker();
  //             //   ll
  //         });
  //     }
  //    }, [])

  useEffect(() => {
    if (!isFetchingStaff) {
      $(function () {
        $(".my-staff-select").selectpicker("destroy");
        $(".my-director-select").selectpicker("destroy");
        //   ll
      });
    }
  }, [isFetchingStaff]);

  useEffect(() => {
    if (flowTypeValue == "option2") {
      $(function () {
        $(".my-director-select").selectpicker("destroy");
        $(".my-staff-select").selectpicker();
        //   ll
      });
    } else if (
      flowTypeValue == "option1" &&
      (user_role.toLowerCase() == "director" ||
        user_role.toLowerCase() == "officers") &&
      notapStaff.length != 0
    ) {
      $(function () {
        $(".my-staff-select").selectpicker("destroy");
        $(".my-director-select").selectpicker();
        //   ll
      });
    } else if (flowTypeValue == "option3") {
      dispatch(
        showSendEvalFormFunc({ modal: false, status: "", evalId: null })
      );
      dispatch(showStatusChangeConfirmationFunc({ modal: true }));
    }
  }, [flowTypeValue, notapStaff]);

  return (
    <div
      className="modal fade show"
      id="basicModal"
      tabIndex="-1"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.3)",
        overflowY: "auto",
      }}
    >
      <div
        style={{ overflowY: "auto" }}
        className="modal-dialog modal-dialog-centered modal-md"
        role="document"
      >
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSend)} autoComplete={"off"} noValidate>
            <div className="modal-header px-4">
              <h5 className="modal-title" id="exampleModalCenterTitle">
                Send Evaluation
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  closeModal();
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  id="exampleRadios1"
                  defaultChecked={true}
                  value="option1"
                  {...register(`${"flowType"}`, {
                    required: {
                      value: true,
                      message: "*this field is required",
                    },
                  })}
                />
                <label className="form-check-label" htmlFor="exampleRadios1">
                  Follow default flow
                </label>
              </div>
              {["dg", "director", "deputydirector"].includes(
                user_role.toLowerCase()
              ) && (
                <>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="exampleRadios2"
                      value="option2"
                      {...register(`${"flowType"}`, {
                        required: {
                          value: true,
                          message: "*this field is required",
                        },
                      })}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="exampleRadios2"
                    >
                      Send to a different staff
                    </label>
                  </div>
                </>
              )}
              {user_role.toLowerCase() == "director" && (
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="exampleRadios3"
                    value="option3"
                    {...register(`${"flowType"}`, {
                      required: {
                        value: true,
                        message: "*this field is required",
                      },
                    })}
                  />
                  <label className="form-check-label" htmlFor="exampleRadios3">
                    Send to the bank
                  </label>
                </div>
              )}
              <>
                {flowTypeValue == "option2" && (
                  <div className="form-group mt-2">
                    <label htmlFor="next_user_email">
                      {user_role.toLowerCase() == "deputydirector"
                        ? "Officers"
                        : "Staff"}
                    </label>
                    <select
                      disabled={isFetchingStaff}
                      className="form-control rounded-0 selectpicker my-staff-select"
                      id="next_user_email"
                      data-live-search={isFetchingStaff ? false : true}
                      {...register("next_user_email", {
                        required: {
                          value: true,
                          message: "*this field is required",
                        },
                      })}
                    >
                      {!isFetchingStaff ? (
                        <option value={""}>
                          {user_role.toLowerCase() == "deputydirector"
                            ? "Select Officer"
                            : "Select Staff"}
                        </option>
                      ) : (
                        <option
                          data-content={`<div style='display:flex; align-items: center;'>
                                            <span class='mr-2 text-capitalize'>Loading</span>
                                            <div>
                                            <div class="sk-fading-circle" style='width: 15px; height: 15px;'>
                                                <div class="sk-circle1 sk-circle"></div>
                                                <div class="sk-circle2 sk-circle"></div>
                                                <div class="sk-circle3 sk-circle"></div>
                                                <div class="sk-circle4 sk-circle"></div>
                                                <div class="sk-circle5 sk-circle"></div>
                                                <div class="sk-circle6 sk-circle"></div>
                                                <div class="sk-circle7 sk-circle"></div>
                                                <div class="sk-circle8 sk-circle"></div>
                                                <div class="sk-circle9 sk-circle"></div>
                                                <div class="sk-circle10 sk-circle"></div>
                                                <div class="sk-circle11 sk-circle"></div>
                                                <div class="sk-circle12 sk-circle"></div>
                                            </div>
                                            </div>
                                         </div>`}
                          value={"loading"}
                        >
                          Loading...
                        </option>
                      )}
                      {user_role.toLowerCase() == "deputydirector" ? (
                        <>
                          {officers.map((notapItem, i) => {
                            return (
                              <option
                                datatokens={`${notapItem.FIRST_NAME} ${notapItem.LAST_NAME} ${notapItem.EMAIL}`}
                                key={i}
                                value={notapItem.EMAIL}
                              >
                                {notapItem.FIRST_NAME} {notapItem.LAST_NAME} (
                                {notapItem.USER_ROLE_TEXT})
                              </option>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          {notapStaff.map((notapItem, i) => {
                            return (
                              <option
                                datatokens={`${notapItem.FIRST_NAME} ${notapItem.LAST_NAME} ${notapItem.EMAIL}`}
                                key={i}
                                value={notapItem.EMAIL}
                              >
                                {notapItem.FIRST_NAME} {notapItem.LAST_NAME} (
                                {notapItem.USER_ROLE_TEXT})
                              </option>
                            );
                          })}
                        </>
                      )}
                    </select>
                    {errors?.next_user_email?.message && (
                      <div className="text-danger small mt-1">
                        {errors?.next_user_email?.message}
                      </div>
                    )}
                  </div>
                )}
              </>
              <>
                {flowTypeValue == "option1" &&
                  (user_role.toLowerCase() == "director" ||
                    user_role.toLowerCase() == "officers") && (
                    <div className="form-group mt-2">
                      <label htmlFor="next_user_email">Deputy Directors</label>
                      <select
                        disabled={isFetchingStaff}
                        className="form-control rounded-0 selectpicker my-director-select"
                        id="next_user_email"
                        data-live-search={isFetchingStaff ? false : true}
                        {...register("next_user_email", {
                          required: {
                            value: true,
                            message: "*this field is required",
                          },
                        })}
                      >
                        {!isFetchingStaff ? (
                          <option value={""}>Select Deputy Director</option>
                        ) : (
                          <option
                            data-content={`<div style='display:flex; align-items: center;'>
                                            <span class='mr-2 text-capitalize'>Loading</span>
                                            <div>
                                            <div class="sk-fading-circle" style='width: 15px; height: 15px;'>
                                                <div class="sk-circle1 sk-circle"></div>
                                                <div class="sk-circle2 sk-circle"></div>
                                                <div class="sk-circle3 sk-circle"></div>
                                                <div class="sk-circle4 sk-circle"></div>
                                                <div class="sk-circle5 sk-circle"></div>
                                                <div class="sk-circle6 sk-circle"></div>
                                                <div class="sk-circle7 sk-circle"></div>
                                                <div class="sk-circle8 sk-circle"></div>
                                                <div class="sk-circle9 sk-circle"></div>
                                                <div class="sk-circle10 sk-circle"></div>
                                                <div class="sk-circle11 sk-circle"></div>
                                                <div class="sk-circle12 sk-circle"></div>
                                            </div>
                                            </div>
                                         </div>`}
                            value={"loading"}
                          >
                            Loading...
                          </option>
                        )}
                        <>
                          {deputyDirectors.map((notapItem, i) => {
                            return (
                              <option
                                datatokens={`${notapItem.FIRST_NAME} ${notapItem.LAST_NAME} ${notapItem.EMAIL}`}
                                key={i}
                                value={notapItem.EMAIL}
                              >
                                {notapItem.FIRST_NAME} {notapItem.LAST_NAME} (
                                {notapItem.USER_ROLE_TEXT})
                              </option>
                            );
                          })}
                        </>
                      </select>
                      {errors?.next_user_email?.message && (
                        <div className="text-danger small mt-1">
                          {errors?.next_user_email?.message}
                        </div>
                      )}
                    </div>
                  )}
              </>
            </div>
            <div className="modal-footer px-4 d-flex align-items-center">
              <button
                disabled={isLoading ? true : false}
                onClick={() => {
                  closeModal();
                }}
                type="button"
                className="btn btn-smoke"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <div>
                {isLoading ? (
                  <Spinner />
                ) : (
                  <button
                    onClick={() => {
                      setValue("status", "approved");
                      setValue("actionWord", "approve");
                    }}
                    type="submit"
                    className="btn btn-success"
                  >
                    Send
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
